import React from "react";
import { SidebarInfo } from "../../components/SidebarInfo";
import animation from "../../layout/OnboardingLayout.module.scss";

export const PayrollSidebar: React.FC = () => (
    <aside>
        <SidebarInfo className={animation.fadeIn2}>
            <header>Don’t have a payroll provider?</header>

            <p>
                For a seamless payroll experience, we recommend using{" "}
                <strong>Gusto</strong>.
            </p>

            <p>
                Our direct integration ensures accurate, real-time
                reconciliation of your payroll transactions.
            </p>
        </SidebarInfo>

        <SidebarInfo className={animation.fadeIn1}>
            <header>
                Why do you want to know what payroll provider I use?
            </header>

            <p>
                Sharing your payroll provider helps Kick maintain accurate
                financials by categorizing payroll-related expenses (payroll,
                taxes, fees).
            </p>
        </SidebarInfo>
    </aside>
);
